import React, { useState,useEffect } from 'react';
import '../styles/pages/page-auth.css';
import { Link } from 'react-router-dom';
import LawyerAddNoAuth from '../page_components/notarial_book/crud_lawyer/lawyer_add_no_auth';

const Register = () => {


  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);



  const [step, setStep] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    full_name: '',
    user_profile_photo: '',
    mobile_number: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleNext = () => setStep(prev => prev + 1);
  const handleBack = () => setStep(prev => prev - 1);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Replace this with your real API endpoint
      const response = await fetch(`${process.env.REACT_APP_API_URL}/register/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      const result = await response.json();

      if (response.ok) {
        alert('Registration successful!');
        setStep(1);
        setFormData({});
      } else {
        alert(result.message || 'Registration failed');
      }
    } catch (err) {
      alert('An error occurred during registration');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="authentication-wrapper authentication-basic ">

            <LawyerAddNoAuth/>

           


      <div className="authentication-inner d-none">
        <div className="card w-100">
          <div className="card-body">
            <div className="app-brand mb-4">
              <a href="/" className="app-brand-link gap-2">
                <span className="fs-3 demo text-body fw-bold">NOTARYO PUBLIKO</span>
              </a>
            </div>
            <h4 className="mb-2">Create Your Account</h4>
            <p className="mb-4">Step {step} of 3</p>


            {/* <form onSubmit={handleSubmit}>
              {step === 1 && (
                <>
                  <div className="mb-3">
                    <label className="form-label">Username</label>
                    <input type="text" name="username" className="form-control" value={formData.username} onChange={handleChange} required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Email</label>
                    <input type="email" name="email" className="form-control" value={formData.email} onChange={handleChange} required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Password</label>
                    <input type="password" name="password" className="form-control" value={formData.password} onChange={handleChange} required />
                  </div>
                </>
              )}

              {step === 2 && (
                <>
                  <div className="mb-3">
                    <label className="form-label">Full Name</label>
                    <input type="text" name="full_name" className="form-control" value={formData.full_name} onChange={handleChange} required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Mobile Number</label>
                    <input type="text" name="mobile_number" className="form-control" value={formData.mobile_number} onChange={handleChange} />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Profile Photo URL</label>
                    <input type="text" name="user_profile_photo" className="form-control" value={formData.user_profile_photo} onChange={handleChange} />
                  </div>
                </>
              )}

              {step === 3 && (
                <>
                  <p><strong>Review your information:</strong></p>
                  <ul className="list-group mb-3">
                    <li className="list-group-item">Username: {formData.username}</li>
                    <li className="list-group-item">Email: {formData.email}</li>
                    <li className="list-group-item">Full Name: {formData.full_name}</li>
                    <li className="list-group-item">Mobile: {formData.mobile_number}</li>
                  </ul>
                </>
              )}

              <div className="d-flex justify-content-between">
                {step > 1 && <button type="button" className="btn btn-secondary" onClick={handleBack}>Back</button>}
                {step < 3 && <button type="button" className="btn btn-primary" onClick={handleNext}>Next</button>}
                {step === 3 &&
                  <button type="submit" className="btn btn-success" disabled={isSubmitting}>
                    {isSubmitting ? 'Registering...' : 'Submit'}
                  </button>
                }
              </div>
            </form> */}

            
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
